import React from 'react'

import { useTranslation } from '../../contexts/I18nContext'

import Styled from './RecipeDirections.styled'

const RecipeDirections = ({ className, directions }) => {
  const { t } = useTranslation()
  return (
    <Styled className={className}>
      {directions.map((step, i) => (
        <Styled.container
          key={step.id || step.label}
          id={`step${i + 1}`}
          data-scroll-offset
        >
          <Styled.involvedIngredients
            ingredientsCount={step.involvedIngredients.length}
          >
            {step.involvedIngredients.map((ingredient) => (
              <Styled.involvedIngredient
                key={ingredient.id || ingredient.name}
                imageUrl={ingredient.imageUrl}
                alt={ingredient.name}
                size="xSmall"
              />
            ))}
          </Styled.involvedIngredients>
          <Styled.step>
            <Styled.position>{`${t('RECIPE.DIRECTION')} ${
              i + 1
            }`}</Styled.position>
            <Styled.description>{step.label}</Styled.description>
          </Styled.step>
        </Styled.container>
      ))}
    </Styled>
  )
}

RecipeDirections.defaultProps = {
  directions: [],
}

export default RecipeDirections
